(ns app.front.ui.unsaved-changes
  "A wrapper component for saving/canceling unsaved changes on inputs"
  (:require [core.front.event :refer [<sub]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub
  ::unsaved-values?
  (fn [db [_ ids]]
    (->> ids
         (some #(contains? (::unsaved-values db) %))
         boolean)))




(rf/reg-sub
  ::unsaved-value
  (fn [db [_ id]]
    (get-in db [::unsaved-values id])))


(rf/reg-event-db
  ::set-unsaved-value
  (fn [db [_ id new-value]]
    (assoc-in db [::unsaved-values id] new-value)))


(rf/reg-event-db
  ::remove-unsaved-values
  (fn [db [_ ids]]
    (-> (reduce #(p/dissoc-in %1 [::unsaved-values %2]) db ids)
        (update ::reset-counter inc))))

;; Rich-text editor value can't be controlled, so rig re-render with this on undo.
(rf/reg-sub ::reset-counter
  :-> ::reset-counter)

(defn- wrap-on-change-fn
  "Wraps the input's original on-change handler (if any) so the unsaved changes are also kept track of"
  [wrapped-on-change-fn id saved-value raw-fn sync?]
  (fn [value]
    (let [raw-value (cond-> value (some? raw-fn) raw-fn)
          event-v   (if (= raw-value saved-value)
                      [::remove-unsaved-values [id]]
                      [::set-unsaved-value id raw-value])]
      (when (some? wrapped-on-change-fn)
        (wrapped-on-change-fn value))
      (if sync?
        (rf/dispatch-sync event-v)
        (rf/dispatch event-v)))))


(defn wrapper
  "Component to wrap input components so their unsaved value is saved in the front db.
  The unsaved value can be accessed by the subscriptions:
  `::unsaved-values?` Returns true if any of the given ids has an unsaved change
  `::unsaved-value`   Returns the unsaved change for the given id (can be nil)

  Props:
  `:id`            any unique value, used to identify the field
  `:raw-fn`        optional fn, returns the raw value from the on-change event (e.g. `futil/tval`) (default identity)
  `:fn?`           optional boolean, if the input should be treated like a function (e.g. `cc/select`) (default false)
  `:sync?`         optional boolean, if the input uses synchronized events (i.e. text input fields) (default false)
  `:on-change-key` optional keyword, what opt key on the input is used for the on-change callback (default :on-change)
  `:value-key`     optional keyword, what opt key on the input is used for the value (default :value)"
  [{:keys [id raw-fn fn? sync? on-change-key value-key]} wrapped-input-fn wrapped-input-opts & wrapped-input-children]
  (let [on-change-key  (or on-change-key :on-change)
        value-key      (or value-key :value)
        raw-fn         (or raw-fn identity)
        saved-value    (get wrapped-input-opts value-key)
        unsaved-value? (<sub [::unsaved-values? [id]])
        unsaved-value  (<sub [::unsaved-value id])
        updated-opts   (-> wrapped-input-opts
                           (update on-change-key wrap-on-change-fn id saved-value raw-fn sync?)
                           (assoc value-key (if unsaved-value?
                                              unsaved-value
                                              saved-value)))]
    (if fn?
      (apply wrapped-input-fn updated-opts wrapped-input-children)
      (into [wrapped-input-fn updated-opts] wrapped-input-children))))
